import CryptoJS from "crypto-js";

export const generateSHA1 = (byteArray) => {
  // Convert the byte array to a WordArray using the full CryptoJS library
  const wordArray = CryptoJS.lib.WordArray.create(byteArray);

  // Generate SHA-1 hash
  const hash = CryptoJS.SHA1(wordArray);

  // Format the hash as "sha-1:XX:XX:..."
  const formattedHash =
    "sha-1:" +
    hash
      .toString()
      .toUpperCase()
      .match(/.{2}/g)
      ?.join(":");

  return formattedHash;
};
